<template>
    <v-card class="clickable article-card" color="#232323" dark @click="goToArticle(article)">
        <v-row no-gutters :style="main && !$vuetify.breakpoint.mobile ? 'height: 600px;' : 'height: 300px;'">
            <v-col :cols="main ? 6 : 7" class="article-left" style="height: 100%;">
                <div class="article-content">
                    <v-card-title class="article-title text-h5" v-text="article?.title" />
                    <v-card-subtitle
                        class="article-subtitle"
                        v-html="contentWithoutImages"
                    />
                </div>
            </v-col>
            <v-col :cols="main ? 6 : 5" class="article-image-col" style="overflow: hidden; height: 100%;">
                <img
                    :src="getArticleImage()"
                    class="white--text align-end article-image"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="300px"
                    width="auto"
                >
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    // import momentTimezone from 'moment-timezone'
    export default {
        props: {
            article: {
                type: Object,
                default: null
            },
            main: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            contentWithoutImages() {
                if (!this.article || !this.article.content) return ''
                try {
                    const parser = new DOMParser()
                    const doc = parser.parseFromString(this.article.content, 'text/html')
                    const selectors = ['img', 'picture', 'figure']
                    selectors.forEach(sel => {
                        const els = doc.querySelectorAll(sel)
                        els.forEach(e => e.remove())
                    })
                    return doc.body.innerHTML
                } catch (e) {
                    return this.article.content
                }
            }
        },
        methods: {
            getArticleImage() {
                return `${'https://storage.googleapis.com'}/${this.article.image}`
            },
            goToArticle(article) {
                this.$router.push({ name: 'Article', params: { id: article.id } })
            }
        }
    }
</script>

<style scoped>
    .article-card {
        width: 100%;
        max-width: 100%;
        display: block;
    }

    .article-left {
        padding: 12px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .article-title {
        text-align: justify;
        word-break: break-word;
        font-weight: 700;
        margin-bottom: 6px;
    }

    .article-subtitle {
        text-align: justify;
        word-break: break-word;
        overflow: hidden;
        display: box;
        -webkit-line-clamp: 3; /* adjust lines to fit the card height */

        /* box-orient: vertical; */
    }

    .article-image {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
</style>
